module.exports = __webpack_public_path__ + "img/home_phone.5ffef8a6.png";